import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/portfolio/risk-assessment-models/page.tsx");
